<template>
        <v-autocomplete
                v-model="model"
                :items="data"
                :label="label"
                :loading="loading"
                :search-input.sync="search"
                :full-width="true"
                clearable
                chips
                deletable-chips
                item-value="id"
                item-text="name"
                multiple
                color="primary"
                :placeholder="$t('inputs.shared.startTypingToSearch')"
        >
            <v-slide-x-reverse-transition
                    slot="append-outer"
                    mode="out-in"
            >
                <v-icon
                        :key="`icon-${isEditing}`"
                        :color="isEditing ? 'success' : 'info'"
                        @click="isEditing = !isEditing"
                        v-text="isEditing ? 'mdi-check-outline' : 'mdi-circle-edit-outline'"
                ></v-icon>
            </v-slide-x-reverse-transition>
        </v-autocomplete>
</template>

<script>
    export default {
        name: "choose-permissions-multi",
        props: ['label', 'value'],
        data() {
            return {
                isEditing: false,
                loading: false,
                model: this.value,
                search: null,
                data: [],
                cached: []
            }
        },
        mounted() {
            this.loading = true;
            this.axios.get(this.api.ACTIONS.PERMISSIONS)
                .then(res => {
                    const {data} = res.data;
                    this.data = data;
                })
                .catch(err => console.log(err))
                .finally(() => this.loading = false);
        },
        watch: {
            model(val) {
                this.$emit("input", val);
            }
        },
        methods: {
            remove(id) {
                this.model = this.model.filter(item => item !== id);
            }
        }
    }
</script>

<style scoped>

</style>